export const MainWrapper = 'col-span-2 grid w-full grid-cols-1 py-4 md:py-6'

export const MainContentWrapper = 'flex flex-col space-y-6'

export const ViewPortContentWrapper = 'flex flex-col space-y-6'

export const TabListWrapper =
  'flex flex-row justify-center space-x-4 md:justify-start md:space-x-14'

export const TabWrapper =
  'flex w-36 flex-col items-center justify-end space-y-4 p-3 transition-colors focus:outline-none'

export const TabSelectedWrapper =
  'border-accentGreen fill-accentGreen border-b-4 '

export const TabNoStateWrapper = 'border-b-4 border-white fill-black'

export const TabDisabledWrapper = 'fill-machine2-50 text-machine2-50'

export const TabTileWrapper = 'font-Roboto text-16 whitespace-nowrap'

export const StandardSubmitButton = 'w-auto min-w-[128px] self-center'
